// src/icons/index.ts
import { ReactComponent as AddIcon } from './icon-add.svg';
import { ReactComponent as CalendarIcon } from './icon-calendar.svg';
// import { ReactComponent as AddIcon } from './icon-add.svg';
import { ReactComponent as AnnounceIcon } from './icon-announce.svg';
// import { ReactComponent as  } from './icon-calendar.svg';
import { ReactComponent as CallIcon } from './icon-call.svg';
import { ReactComponent as ChangePasswordIcon } from './icon-change-password.svg';
import { ReactComponent as DelegateIcon } from './icon-delegate.svg';
import { ReactComponent as DeleteIcon } from './icon-delete.svg';
import { ReactComponent as DownloadIcon } from './icon-download.svg';
import { ReactComponent as DraftIcon } from './icon-draft.svg';
import { ReactComponent as EditIcon } from './icon-edit.svg';
import { ReactComponent as EmailIcon } from './icon-email.svg';
import { ReactComponent as FilterIcon } from './icon-filter.svg';
import { ReactComponent as InfoIcon } from './icon-info.svg';
import { ReactComponent as LogoutIcon } from './icon-logout.svg';
import { ReactComponent as MoreVertIcon } from './icon-more-vert.svg';
import { ReactComponent as MyInfoIcon } from './icon-my-info.svg';
import { ReactComponent as NotificationsIcon } from './icon-notifications.svg';
import { ReactComponent as PaymentIcon } from './icon-payment.svg';
import { ReactComponent as PdfIcon } from './icon-pdf.svg';
import { ReactComponent as RefreshIcon } from './icon-refresh.svg';
import { ReactComponent as UploadAltIcon } from './icon-upload-alt.svg';
import { ReactComponent as UserIcon } from './icon-user.svg';
import { ReactComponent as ViewIcon } from './icon-view.svg';
import { ReactComponent as WhatsAppIcon } from './icon-whatsapp.svg';

import { ReactComponent as AllocationIcon } from './icon-allocation.svg';
import { ReactComponent as ApproveIcon } from './icon-approve.svg';
import { ReactComponent as AutoReconcileIcon } from './icon-auto-reconciliation.svg';
import { ReactComponent as FieldVerificationIcon } from './icon-field-verification.svg';
import { ReactComponent as FieldVisitIcon } from './icon-field-visit.svg';
import { ReactComponent as HideColumnsIcon } from './icon-hide-columns.svg';
import { ReactComponent as LoginIcon } from './icon-login.svg';
import { ReactComponent as ManualReconcileIcon } from './icon-manual-reconciliation.svg';
import { ReactComponent as RejectIcon } from './icon-reject.svg';
import { ReactComponent as FilterAppliedIcon } from './icon-search-filter-apply.svg';
import { ReactComponent as SearchLensIcon } from './icon-search-lens.svg';
import { ReactComponent as TeleVerificationIcon } from './icon-tele-verification.svg';
import { ReactComponent as Vernacular } from './icon-vernacular.svg';
import { ReactComponent as LocationPin } from './icon-geo-location.svg';
import { ReactComponent as GenerateIcon } from './icon-generate.svg';
import { ReactComponent as GenerateSPIS } from './icon-generate-spis.svg';
import { ReactComponent as GenerateBPIS } from './icon-generate-bpis.svg';


const svgIcons: { [key: string]: React.FunctionComponent<React.SVGProps<SVGSVGElement>> } = {
  add: AddIcon,
  "fa-add": AddIcon,
  "fa-plus": AddIcon,
  calendar: CalendarIcon,
  announce: AnnounceIcon,
  call: CallIcon,
  "fa-phone": CallIcon,
  changePassword: ChangePasswordIcon,
  delegate: DelegateIcon,
  delete: DeleteIcon,
  "fa-move-to": DelegateIcon,
  faTrash: DeleteIcon,
  'fa-trash-alt': DeleteIcon,
  download: DownloadIcon,
  "fa-download": DownloadIcon,
  draft: DraftIcon,
  "fa-file-text": DraftIcon,
  edit: EditIcon,
  "fa-edit": EditIcon,
  "Approve": EditIcon,
  email: EmailIcon,
  "fa-envelope": EmailIcon,
  filter: FilterIcon,
  info: InfoIcon,
  "fa-circle-info": InfoIcon,
  logout: LogoutIcon,
  moreVertical: MoreVertIcon,
  myInfo: MyInfoIcon,
  notifications: NotificationsIcon,
  payment: PaymentIcon,
  "fa-money-check-pen": PaymentIcon,
  pdf: PdfIcon,
  "faFilePdf": PdfIcon,
  refresh: RefreshIcon,
  uploadAlt: UploadAltIcon,
  "fa-upload": UploadAltIcon,
  user: UserIcon,
  view: ViewIcon,
  "fa-eye": ViewIcon,
  whatsapp: WhatsAppIcon,
  "fa-whatsapp": WhatsAppIcon,
  allocation: AllocationIcon,
  Allocate : AllocationIcon,
  TVR : TeleVerificationIcon,
  "Field Verification": FieldVerificationIcon,
  approve: ApproveIcon,
  autoReconcile: AutoReconcileIcon,
  fieldVerification: FieldVerificationIcon,
  fieldVisit: FieldVisitIcon,
  hideColumns: HideColumnsIcon,
  login: LoginIcon,
  manualReconcile: ManualReconcileIcon,
  reject: RejectIcon,
  filterApplied: FilterAppliedIcon,
  searchLens: SearchLensIcon,
  teleVerification: TeleVerificationIcon,
  vernacular: Vernacular,
  locationPin : LocationPin,
  generate : GenerateIcon,
  generateBPIS : GenerateBPIS,
  generateSPIS : GenerateSPIS,
};

export default svgIcons;
